import { RouteRecordRaw } from 'vue-router'
import { captureOpenInAppUrl } from 'modules/DispenseIdentity/captureOpenInAppUrl'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/BlankLayout/BlankLayout.vue'),
    children: [
      {
        name: 'auth.register',
        path: '/register',
        meta: { unauthOnly: true },
        component: () => import('src/auth/pages/IdentityPasswordRegisterPage.vue'),
      },
      {
        name: 'auth.login',
        path: '/login',
        meta: { unauthOnly: true },
        component: () => import('src/auth/pages/IdentityPasswordLoginPage.vue'),
      },
      {
        name: 'auth.requestPasswordReset',
        path: '/forgot-password',
        meta: { unauthOnly: true },
        component: () => import('src/auth/pages/PasswordResetRequestViaEmailPage.vue'),
      },
      {
        name: 'auth.resetPassword',
        path: '/password-reset',
        meta: { unauthOnly: true },
        component: () => import('src/auth/pages/PasswordResetViaEmailPage.vue'),
      },
      {
        path: '',
        name: 'dashboard-redirect',
        redirect: 'org',
      },
      {
        name: 'select.tenant.org',
        path: 'org',
        component: () => import('pages/SelectTenantAndOrgPage/SelectTenantAndOrgPage.vue'),
        meta: { authOnly: true },
      },
    ],
  },
  {
    path: '/',
    component: () => import('layouts/AuthenticatedLayout.vue'),
    meta: {
      authOnly: true,
    },
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('src/pages/UserDashboard/UserDashboard.vue'),
        meta: { authOnly: true, hideBackButton: true },
      },
      {
        name: 'ble',
        path: 'ble',
        component: () => import('pages/BleScanDevices/BleScanDevices.vue'),
      },
      {
        name: 'testqr',
        path: 'testqr',
        component: () => import('pages/TestQR/TestQR.vue'),
      },
      {
        name: 'TestGeo',
        path: 'TestGeo',
        component: () => import('pages/TestGeo/TestGeo.vue'),
      },
      {
        name: 'dispense',
        path: 'dispense',
        component: () => import('pages/DispensePage/DispensePage.vue'),
        meta: {
          authOnly: true,
        },
      },
      {
        name: 'openInApp',
        path: 'oia/:rest*',
        meta: { authOnly: true },
        redirect: (to) => {
          const origin = typeof window === 'undefined' ? 'http://localhost' : window.location.origin
          captureOpenInAppUrl(new URL(to.fullPath, origin).href)
          return { name: 'dashboard' }
        },
      },
      {
        name: 'multipleDispense',
        path: 'multiple-dispense',
        component: () => import('pages/MultipleDispensePage/MultipleDispensePage.vue'),
      },
      {
        name: 'logbook',
        path: 'logbook',
        component: () => import('../pages/LogbookPage/LogbookPage.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('pages/SettingsPage/SettingsPage.vue'),
      },
      {
        name: 'levels',
        path: 'levels',
        component: () => import('pages/LevelsPage/LevelsPage.vue'),
      },
      {
        name: 'assets',
        path: 'assets',
        component: () => import('pages/AssetsPage/AssetsPage.vue'),
      },
      {
        name: 'users',
        path: '/users',
        component: () => import('pages/UsersPage/UsersPage.vue'),
        meta: { authOnly: true },
      },
      {
        name: 'manageDevices',
        path: 'devices',
        component: () => import('pages/ManageDevicesPage/ManageDevicesPage.vue'),
      },

      {
        name: 'manageDevice.details',
        props: true,
        path: 'devices/:deviceId/details',
        meta: { hideFooter: true },
        component: () => import('pages/ManageDevicePage/ManageDevicePage.vue'),
      },
      {
        name: 'manageDevice.config',
        props: true,
        path: 'devices/:deviceId/config',
        meta: { hideFooter: true },
        component: () => import('pages/ManageDevicePage/ManageDevicePage.vue'),
      },
      {
        name: 'manageDevice.telemetry',
        props: true,
        path: 'devices/:deviceId/telemetry',
        meta: { hideFooter: true },
        component: () => import('pages/ManageDevicePage/ManageDevicePage.vue'),
      },
      {
        name: 'manageDevice.calibrate',
        props: true,
        path: 'devices/:deviceId/calibrate',
        meta: { hideFooter: true },
        component: () => import('pages/ManageDevicePage/ManageDevicePage.vue'),
      },
      {
        name: 'manageDevice.audit',
        props: true,
        path: 'devices/:deviceId/audit',
        meta: { hideFooter: true },
        component: () => import('pages/ManageDevicePage/ManageDevicePage.vue'),
      },
      {
        name: 'manageDevice.history',
        props: true,
        path: 'devices/:deviceId/history',
        meta: { hideFooter: true },
        component: () => import('pages/ManageDevicePage/ManageDevicePage.vue'),
      },
      {
        name: 'equipmentdetails',
        path: 'assets/:id',
        component: () => import('pages/AssetsPage/EquipmentDetail.vue'),
        props: true,
      },
      {
        name: 'calibrationdetails',
        path: 'calibrationdetails/:id',
        component: () => import('pages/AssetsPage/CalibrationDetail.vue'),
        props: true,
      },
      {
        name: 'help',
        path: 'help',
        component: () => import('pages/HelpPage/HelpPage.vue'),
        props: false,
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('pages/SettingsPage/SettingsPage.vue'),
        props: false,
      },
      {
        name: 'appterms',
        path: 'appterms',
        component: () => import('pages/AppTerms/AppTerms.vue'),
        props: false,
      },
      {
        name: 'appprivacy',
        path: 'appprivacy',
        component: () => import('pages/AppPrivacy/AppPrivacy.vue'),
        props: false,
      },
      {
        name: 'queue.view',
        path: 'queue',
        component: () => import('pages/ViewQueuePage/ViewQueuePage.vue'),
      },
      {
        name: 'transactionsView',
        path: 'transactionsView',
        component: () => import('pages/TransactionsPage/TransactionsPage.vue'),
      },
      {
        name: 'whatsNewView',
        path: 'whatsNewView',
        component: () => import('pages/WhatsNewPage/WhatsNewPage.vue'),
      },
    ],
  },

  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
]

export default routes
